// extracted by mini-css-extract-plugin
module.exports = {"header":"views-RecentlyPlayed__header--3FCcs","collectionEmptyIcon":"views-RecentlyPlayed__collectionEmptyIcon--3rcmB","item":"views-RecentlyPlayed__item--Jn7vL"};